// FIXME: Add correct message.
const errorMessage = {
  status: -1,
  message: 'Beklenmeyen bir hata oluştu. \nLütfen daha sonra tekrar deneyin.',
  errors: [{
    domain: null,
    code: -1,
    message: 'Beklenmeyen bir hata oluştu. \nLütfen daha sonra tekrar deneyin.',
    location: null,
    locationType: 'modalbox'
  }]
};

export default errorMessage;
